import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useMutate } from "../../Hooks/use-mutate";
import { useGetInstance } from "../../Hooks/use-get";
import { PageLayout } from "../../Components/PageLayout";
import { Card } from "../../Components/ui/card";
import { Form } from "../../Components/ui/form/form";
import { Input, Select } from "../../Components/ui/form";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";
import { SearchSelect } from "../../Components/ui/form/search-select/search-select";
import { Button } from "../shared";

type UserPostData = {
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  location_id: number;
  group_id: number;
};

type SearchSelectOption = {
  label: string;
  value: string | number;
};

type LocationOption = {
  id: number;
  loc_name: string;
};

const UserCreateRoute = () => {
  const navigate = useNavigate();

  const groups = useGetInstance<{ id: number; name: string }[]>("/api/groups/");

  const createUser = useMutate<UserPostData, { id: number }>(
    "/api/users/",
    "POST",
  );

  const [location, setLocation] = React.useState<SearchSelectOption | null>(
    null,
  );

  const handleSubmit = async (e: React.SubmitEvent) => {
    try {
      e.preventDefault();
      const formData = new FormData(e.target as HTMLFormElement);
      const data: UserPostData = {
        first_name: formData.get("first_name") as string,
        last_name: formData.get("last_name") as string,
        username: formData.get("username") as string,
        email: formData.get("email") as string,
        location_id: location?.value as number,
        group_id: Number(formData.get("group_id")),
      };
      const response = await createUser.mutate(data);
      if (response.status === 201) {
        navigate("/users");
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  return (
    <PageLayout title="Create User" header="">
      <Button
        variant="secondary"
        onClick={() => navigate("/users")}
        labelKey="back"
      />
      <br />
      <Card title="createUser" titleKey="createUser" size="md">
        <Form
          onSubmit={handleSubmit}
          isLoading={createUser.isLoading}
          submitLabel="create"
        >
          <Input name="first_name" label="firstName" required />
          <Input name="last_name" label="lastName" required />
          <Input name="username" label="username" required />
          <Input name="email" label="email" type="email" required />
          <SearchSelect
            onChange={(selected) => setLocation(selected)}
            label="location"
            value={location}
            url="/assets/locations/v2/?is_active=true&name="
            accessor={{
              optionLabel: (item) => (item as LocationOption).loc_name,
              optionValue: (item) => (item as LocationOption).id,
            }}
            required
          />
          {groups.isLoading ? (
            <Spinner />
          ) : (
            <Select
              name="group_id"
              label="role"
              options={
                groups.data?.map((group) => ({
                  optionValue: group.id,
                  optionLabel: group.name,
                })) || []
              }
            />
          )}
        </Form>
      </Card>
    </PageLayout>
  );
};

export default UserCreateRoute;
